import React from "react";

// Renders nothing when there is no text, so an empty disclaimer does not
// leave a stray coloured strip at the top of the page.
const SaleBanner = ({ children }) => {
  const hasContent = React.Children.toArray(children).some(
    (child) => typeof child !== "string" || child.trim()
  );

  if (!hasContent) return null;

  return <div className="sale-banner">{children}</div>;
};

export default SaleBanner;
